var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swap.wrongchain",
    transform: "translate(-436.000000, -155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "general/connect",
    transform: "translate(436.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00C087",
    cx: 6,
    cy: 6,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25158893,5.24974867 L5.73562175,5.73376378 C5.41682223,6.05257496 5.39444803,6.54843897 5.66762709,6.87184783 L5.68928168,6.89533644 L5.69054122,6.89442717 L7.25467112,8.45855706 C7.57496441,8.77885035 8.10673233,8.771721 8.44231408,8.43613925 C8.76111785,8.11733549 8.78348883,7.62147798 8.51030506,7.2980757 L8.46471478,7.24849629 L7.10676028,5.89054178 L7.59078424,5.40651782 L8.9487342,6.76446778 C9.53931346,7.35502485 9.52638137,8.32011989 8.92633805,8.92016321 C8.34698993,9.49951133 7.4273313,9.53155077 6.83304529,9.00152134 L6.77064716,8.94258102 L5.23134232,7.40338218 L5.22919266,7.40545225 C4.658989,6.83524858 4.65138858,5.91590872 5.19161223,5.3130944 L5.25158893,5.24974867 Z M4.82409475,2.64883693 L4.88649445,2.70777772 L6.44334148,4.26475201 L6.44380036,4.26427857 C7.01400403,4.83448223 7.02160445,5.7538221 6.48138079,6.35663641 L6.4214041,6.41998214 L5.93737128,5.93596703 C6.25617079,5.61715586 6.278545,5.12129184 6.00536593,4.79788298 L5.96658406,4.75591013 L4.40247316,3.19180436 C4.08216504,2.87150226 3.55039548,2.87863009 3.21481417,3.21421139 C2.89601582,3.53300508 2.87364258,4.02887754 3.14681914,4.3522785 L3.19240825,4.40185757 L4.55036446,5.75981207 L4.0663408,6.24383634 L2.70838716,4.88588441 C2.11781671,4.29532727 2.13075368,3.33021518 2.73079198,2.73018566 C3.31013779,2.15083985 4.22979466,2.11880312 4.82409475,2.64883693 Z",
    id: "Shape",
    fill: "#FFFFFF",
    transform: "translate(5.828565, 5.825177) scale(-1, 1) translate(-5.828565, -5.825177) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.970e094c9bab4fc835265437c27ee9e2.svg";
export { ForwardRef as ReactComponent };